import React from 'react';
import { Button } from '@material-ui/core';
import { getFullItemName } from '../../../../utils/mrs-util';
import ItemIcon from '../ItemIcon';
import { getRegionalColors } from '../../../../utils/regional-colors';
import { formatNumber } from '../../../../utils/format-number-util';
import '../ItemRow/ItemRow.css';

const ReviewItemRow = (props) => {
  return (
    <div className="item-row-container">
      <div className="item-row-item-container">
        <div className="item-row-delivery-values-container">
          <div>
            <div className="item-row-delivery-value-label">Freq</div>
            <div className="item-row-delivery-value-number">
              {props.frequency}
            </div>
          </div>
          <div>
            <div className="item-row-delivery-value-label">Qty</div>
            <div className="item-row-delivery-value-number">{props.qty}</div>
          </div>
        </div>
        <div className="item-row-edit-container">
          <Button className="item-row-edit-button" disabled={true}>
            <div className="item-row-edit-button-content">
              <div>
                <ItemIcon item={props.item} />
              </div>
            </div>
          </Button>
        </div>
        <div className="review-item-row-item-info-container">
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div style={{ marginRight: 10 }}>
              <div style={{ fontSize: 18 }}>{props.item.description}</div>
              <div className="item-row-item-info-description">
                {getFullItemName(props.item)}
              </div>
            </div>
            <div>
              <div style={{ fontSize: 12, marginRight: 15 }}>
                First/Prev Del:
              </div>
              <div
                style={{
                  textAlign: 'right',
                  color: getRegionalColors().backgroundColor
                }}
              >
                {props.owGroup}
              </div>
            </div>
          </div>
          <div className="item-row-item-info-uses-price-container">
            <div>Uses: {props.item.numberOfUses}</div>
            <div>Price: ${formatNumber(props.rate, 2)}</div>
            <div>RepRate: ${formatNumber(props.item.replaceRate, 2)}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReviewItemRow;
